'use client';

import Image from 'next/image';
import { buildContentstackImageUrl } from '@/lib/utils';
import { renderRte } from '@/utils/rte';
import { useModal } from '@/components/ModalContext';
import SocialProofModal from './SocialProofModal';

// BL-852: split out from SocialProof.js so the server component only pays
// client JS for cards that actually need the modal, not the whole block.
const SocialProofCard = ({ card }) => {
  const { openModal } = useModal();
  const descriptionHtml = renderRte(card.card_details);
  const title = card.card_heading;

  const image = (
    <Image
      src={buildContentstackImageUrl(card.image.url)}
      width={160}
      height={160}
      alt={card.image.description || card.image.title || card.card_heading || ''}
      sizes="160px"
      className="max-h-full w-auto object-contain"
    />
  );

  // Cards without modal content stay display-only rather than opening an
  // empty modal.
  if (!descriptionHtml) return image;

  const handleClick = () => {
    openModal(
      <SocialProofModal descriptionHtml={descriptionHtml} />,
      'max-w-3xl xl:max-w-5xl 2xl:max-w-6xl',
      'bg-warm-white',
      { ariaLabel: title ? `Learn more about ${title}` : 'Learn more about this certification' },
    );
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={title ? `Learn more about ${title}` : 'Learn more about this certification'}
      aria-haspopup="dialog"
      className="flex h-full w-full items-center justify-center cursor-pointer"
    >
      {image}
    </button>
  );
};

export default SocialProofCard;
